import { Navigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'

// Nested inside the existing /app/admin ProtectedRoute (requiredRole='drivetrack_admin'),
// which has already confirmed the caller is signed in as drivetrack_admin and not
// suspended — this only adds the superadmin-tier check for the Admins page itself.
// Client-side only, same as every other nav-visibility check in this app: the real
// authorization boundary is server-side (is_superadmin() in migration 068, checked
// independently by every RPC/Edge Function this page calls).
export function RequireSuperadmin({ children }: { children: React.ReactNode }) {
  const { profile } = useAuth()
  if (!profile?.is_superadmin) return <Navigate to='/app/admin' replace />
  return <>{children}</>
}
